import * as style from "./style";

export const Title: React.FC = ({ children }) => {
  return <style.Title>{children}</style.Title>;
};
